<template>
    <div class="content-body tenant-settings">
        <div class="">
            结算管理（暂时没做）
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item label="供应商编码:">
                <el-input size="small" v-model="dataForm.ordeCode" placeholder="供应商编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="业务联系人:">
                    <el-input size="small" v-model="dataForm.projectStatus" placeholder="业务联系人" clearable></el-input>
                </el-form-item>
                <el-form-item label="供应商状态:">
                    <el-input size="small" v-model="dataForm.projectStatus" placeholder="供应商状态" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="getDataList()" icon="el-icon-search">
                        查询
                    </el-button>
                    <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                        新建订单
                    </el-button>
                    <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                        导入订单
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataList" row-key="id" size="small" bProject style="width: 100%;" :default-expand-all="false">
                <el-table-column
                        type="index"
                        width="50"
                        label="序号">
                </el-table-column>
                <el-table-column
                        prop="supplierCode"
                        header-align="left"
                        align="left"
                        label="供应商编码">
                </el-table-column>
                <el-table-column
                        prop="supplierName"
                        header-align="left"
                        align="left"
                        label="供应商名称名称">
                </el-table-column>
                <el-table-column
                        prop="supplierTel"
                        header-align="left"
                        align="left"
                        label="电话">
                </el-table-column>
                <el-table-column
                        prop="supplyProduct"
                        header-align="left"
                        align="left"
                        label="主要供货产品">
                </el-table-column>
                <el-table-column
                        prop="supplyCarStyle"
                        header-align="left"
                        align="left"
                        label="所供车型">
                </el-table-column>
                <el-table-column
                        prop="contactor"
                        header-align="left"
                        align="left"
                        label="业务联系人">
                </el-table-column>
                <el-table-column
                        prop="contractorMobile"
                        header-align="left"
                        align="left"
                        label="手机">
                </el-table-column>
                <el-table-column
                        prop="supplierStatus"
                        header-align="left"
                        align="left"
                        label="状态">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        header-align="left"
                        align="left"
                        label="创建时间"
                        :formatter="dateFormat">
                </el-table-column>
                <el-table-column header-align="left" align="left" min-width="130" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </div>
</template>

<script>
    // import {fetchSupplierList, deleteSupplier} from '@/controller/sys'
    import AddOrUpdate from './pay-add-or-update'  
    import moment from 'moment'
    require('@/mock/mockSupplier');
    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 250,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                tenantList: [],
                pageIndex: 1,
                pageSize: 100000,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate
        },
        activated() {
            this.getDataList()
        },
        methods: {
            dateFormat:function(row,column){
                var date = row[column.property]
                if(date == undefined){return ''}
                return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
            // 新增或编辑子节点
            addChildHandle(id, parentId, parentName, parentNodePath) {
                
                console.log(id, parentId, parentName, parentNodePath)
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
                })
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                // fetchSupplierList(                        
                //     // {
                //     //     'orgCode': this.dataForm.code,
                //     //     'orgName': this.dataForm.name
                //     // }
                // ).then(data => {
                //     console.log(data, 'data')
                //     if (data && data.code === '00') {
                //         this.dataList = data.body
                //         this.totalPage = data.body.total
                //     } else {
                //         this.dataList = []
                //         this.totalPage = 0
                //     }
                //     this.dataListLoading = false
                // })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(row) {
                console.log(row)
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(row, row?row.id: null, 0, null, null, null)
                })
            },
            // 删除
            deleteHandle(id) {
                console.log(id)
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // deleteSupplier(
                    //     {}, id
                    // ).then(data => {
                    //     if (data && data.code === '00') {
                    //         this.$message({
                    //             message: '操作成功',
                    //             type: 'success',
                    //             duration: 1500,
                    //             onClose: () => {
                    //                 this.getDataList()
                    //             }
                    //         })
                    //     } else {
                    //         this.$message.error(data.msg)
                    //     }
                    // })
                })
            }
        }
    }
</script>